module.exports = __webpack_public_path__ + "media/images/players/ANCER_ABRAHAM-2ade7ea3a7fdea1561875e458ed1961a.png";